import React from 'react';

interface VeryWideProps {}

export function VeryWide(props: Readonly<VeryWideProps>) {
	return (
		<svg width={90} height={90} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_11610)">
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.967 95.943v-3.82H10.502V80.57H6.289v13.48c0 1.04.939 1.893 2.087 1.893h12.591z"
				/>
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.387 65.91h6.588c.856 0 1.501.824 1.555 1.824l.72 13.104c0 .991-.702 1.824-1.555 1.824H4.77c-.852 0-1.601-.823-1.554-1.824l.617-13.104c.045-1.002.697-1.824 1.553-1.824z"
				/>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M69.93 95.943v-3.82h10.465V80.57h4.213v13.48c0 1.04-.94 1.893-2.087 1.893H69.93z"
				/>
				<mask
					id="a"
					x={75}
					y={65}
					width={12}
					height={18}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M75.894 65.91H86.93v16.752H75.894V65.91z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M84.757 65.938h-6.461c-.84 0-1.472.817-1.525 1.808l-.706 12.998c-.053.99.688 1.808 1.526 1.808h7.77c.837 0 1.555-1.253 1.51-2.246l-.59-12.56c-.045-.993-.685-1.808-1.524-1.808z"
					/>
				</g>
				<path
					fill="#282626"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M40.39 92.571v-9.907h10.09v9.907H40.39z"
				/>
				<path
					fill="#373D4A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M42.27 77.578h10.088v5.428H42.27v-5.428z"
				/>
				<mask
					id="b"
					x={18}
					y={24}
					width={53}
					height={63}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M18.695 24.035h51.431v62.73h-51.43v-62.73z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M29.953 24.035h30.203c3.098 0 5.286 1.353 5.632 5.933l3.843 50.79c.346 4.582-2.54 5.935-5.633 5.935H26.113c-3.095 0-5.981-1.346-5.636-5.935l3.843-50.79c.348-4.589 2.535-5.933 5.633-5.933z"
					/>
				</g>
				<path
					fill="#3E454A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M69.707 82.664c-.116 3.21-2.799 4.188-5.658 4.188H26.16c-2.861 0-5.543-.974-5.66-4.188h49.207zM14.02 80.57c0 1.882-.465 2.094-2.56 2.094H5.18c-.63 0-2.094 0-1.955-2.094h10.797zM86.912 80.57c0 1.882-.467 2.094-2.56 2.094H78.07c-.63 0-2.094 0-1.955-2.094h10.797z"
				/>
				<path
					fill="#999"
					d="M63.967 50.97c.369-.47 1.72-2.551 2.148-3.271.428-.72.965-1.596 1.374-2.435.443-.907 1.22-2.421 1.78-3.523.476-.94 2.236-4.455-.455-7.623-1.37-1.183-2.702-1.566-5.634-2.228-4.181-.943-4.315-.473-8.337-2.047-1.896-.744-2.848-1.8-3.768-3.381-.32-.55.043-3.021 0-3.54-.038-.466-.5-.832-1.07-.832l-11.13-.016c-.579 0-1.065.374-1.08.848-.02.701.33 2.945 0 3.54-.493 1.312-2.1 2.609-4.411 3.38-2.296.865-3.362 1.074-7.283 2.153-1.361.374-3.293.986-4.34 1.775-.8.602-1.523 1.845-1.752 2.646-.228.8-.242 2.738.495 4.664.738 1.926 1.762 3.56 1.925 4.03.164.47 1.147 2.59 1.475 3.195.328.605 1.244 2.188 1.392 2.377.148.19.86 1.276 1.147 1.746.164.302.671 1.247.82 1.544.3.606 2.668 4.602 2.873 6.08.295 2.125.533 6.474.533 9.015-.343 4.038-.333 10.282-2.123 18.83-.201.964-.147 2.118 0 3.461.407 3.71 2.976 8.981 17.229 8.981s16.4-7.806 16.546-8.98c.147-1.176.183-2.019 0-3.462-.182-1.444-2.186-14.296-2.491-18.83-.132-1.972 0-6.997.305-9.016.338-2.245 1.636-5.483 2.82-7.505.234-.401.644-1.106 1.012-1.576z"
				/>
				<path
					fill="#7F7F7F"
					d="M38.827 2.287C39.88 1.664 42.37 1 43.894 1s3.833.116 5.719 1.287c1.886 1.17 2.576 2.037 3.008 2.752.431.714 1.384 2.835 1.747 4.598a12.47 12.47 0 01.167 4.086c-.203 1.668-1.101 4.515-1.868 5.885-.766 1.37-3.054 5.54-4.176 6.874-1.122 1.334-2.049 1.74-4.402 1.74-2.082 0-3.424-1.216-4.343-2.217-.919-1-3.503-5.384-3.85-5.956-.348-.572-1.818-3.455-2.05-5.373-.23-1.918-.18-3.859 0-5.04.182-1.18.942-3.204 1.847-4.597.904-1.394 2.08-2.13 3.134-2.752zM10.755 66.265a4.751 4.751 0 01-1.757.57 3.845 3.845 0 01-1.71-.186 3.545 3.545 0 01-1.402-.913 3.983 3.983 0 01-.88-1.502c-.29-.883-.305-2.28-.1-2.884.134-.394.323-.935.524-1.428.39-.973.71-1.474 1.256-2.375 1.105-1.809.912-1.393 1.923-2.942 1.035-2.014 1.996-3.63 3.676-7.57a61.054 61.054 0 013.77-7.427c.363-.58.709-1.126 1.013-1.625l.03-.061c.462-.687.882-1.328 1.216-1.813a7.787 7.787 0 012.224-1.868 6.944 6.944 0 012.58-.83 5.62 5.62 0 012.506.284c.782.28 1.518.639 2.05 1.352.515.757.692 1.515.768 1.944.098.562.593 2.046-.235 5.157-.218.818-.61 1.648-.71 1.85-.101.203.094-.186 0 0-1.068 2.147-2.273 3.997-3.673 5.85-1.413 1.87-2.666 3.131-2.666 3.131-1.214 1.352-1.47 1.54-2.5 2.789-.94 1.138-2.017 2.599-2.94 3.866-.81 1.323-2.08 3.142-2.41 3.669-.541.869-.815 1.423-1.254 1.932-.438.508-.741.717-1.299 1.03zM79.359 64.643c.57.29 1.168.463 1.76.51a3.812 3.812 0 001.687-.239 3.513 3.513 0 001.36-.95c.374-.422.654-.937.823-1.515.26-.883.23-2.268.007-2.86-.144-.386-.349-.916-.564-1.397-.417-.952-.75-1.438-1.32-2.313-1.153-1.757-.948-1.351-1.999-2.853-1.09-1.963-2.093-3.534-3.883-7.382a60.52 60.52 0 00-3.972-7.238c-.378-.563-.737-1.092-1.055-1.577l-.032-.06c-.48-.666-.916-1.287-1.262-1.757a7.72 7.72 0 00-2.263-1.78 6.883 6.883 0 00-2.582-.74 5.571 5.571 0 00-2.473.36c-.766.304-1.484.681-1.987 1.405a4.918 4.918 0 00-.7 1.95c-.08.56-.522 2.045.398 5.1.242.804.656 1.614.762 1.811.106.197-.1-.181 0 0 1.127 2.092 2.379 3.887 3.825 5.678a33.582 33.582 0 002.74 3.017c1.247 1.3 1.506 1.479 2.567 2.683.967 1.097 2.08 2.51 3.035 3.736.844 1.285 2.162 3.047 2.504 3.558.565.844.854 1.384 1.305 1.874.45.49.757.687 1.319.98z"
				/>
				<path
					fill="#999"
					d="M7.187 84.563c.117.09 2.254 1.891 3.22 1.696 1.04-.493 1.16-1.266 1.127-1.558-.05-.454-1.755-3.312-1.896-4.436-.171-1.369.19-2.532.754-3.577 0 0 .406.832 1.118 1.45.608.527.57 2.027 1.426 1.913.855-.114.69-2.251.589-2.91-.126-.825-.354-1.832-.503-2.289-.149-.457-.497-1.085-.86-1.625-.455-.678-1.226-1.632-1.354-1.762 0 0-.277-.35-.85-.48 0 0-.897-.044-1.54.086-.642.13-1.125.51-1.411.796-.287.287-.983 1.617-1.35 2.16-.368.543-.822 1.85-.812 1.912 0 0-.264.76-.539 1.876-.063.63-.685 1.568-.685 1.568-.337.538-.336.903-.336.903-.063.678.236 1.004.828 1.286.535.301 1.027 1.3 1.534 1.651.508.35 1.423 1.251 1.54 1.34zM82.842 84.558c-.117.09-2.249 1.898-3.214 1.705-1.042-.489-1.164-1.262-1.133-1.554.05-.454 1.745-3.317 1.883-4.442.167-1.37-.198-2.531-.765-3.575 0 0-.404.834-1.114 1.453-.606.53-.564 2.03-1.42 1.918-.856-.111-.696-2.249-.597-2.909.123-.825.348-1.832.495-2.29.147-.457.494-1.086.855-1.627.453-.68 1.22-1.636 1.349-1.766 0 0 .276-.35.848-.482 0 0 .897-.048 1.54.08.644.13 1.127.506 1.415.793.287.286.987 1.614 1.356 2.155.37.542.827 1.847.818 1.91 0 0 .266.759.544 1.873.066.632.69 1.567.69 1.567.34.537.34.902.34.902.064.677-.234 1.004-.826 1.289-.533.302-1.022 1.303-1.528 1.655-.507.352-1.42 1.256-1.536 1.345z"
				/>
				<path
					fill="#999"
					d="M11.622 73.894c-.43.225-.846.334-1.43.385-.584.052-.914.038-1.2-.022-.343-.071-.76-.174-1.087-.423-.408-.312-.748-1.243-.855-1.546-1.282-3.616-.44-1.736-1.785-4.535-.616-2.114-.782-2.77-.875-3.782-.094-1.013.527-1.782.892-2.126.365-.344.99-.75 1.945-.895 1.242-.114 1.72-.099 2.758.163.894.226 1.264.645 1.571.869.37.269.921 1.13 1.035 1.515.322 1.227.217 1.48-.016 2.77-.213 1.027-.17 1.546-.362 2.584-.159 1.15-.182 1.917-.151 2.5.025.481.171 1.45.15 1.786-.022.337-.183.543-.59.757zM78.531 73.941c.446.233.877.344 1.482.395.605.051.947.036 1.243-.026.355-.076.787-.183 1.124-.443.422-.324.77-1.289.881-1.604 1.316-3.748.45-1.799 1.834-4.702.631-2.19.801-2.871.895-3.92.093-1.049-.551-1.843-.93-2.198-.38-.355-1.029-.775-2.018-.921-1.286-.115-1.782-.097-2.856.177-.925.237-1.307.672-1.625.905-.381.28-.95 1.173-1.066 1.572-.33 1.272-.22 1.534.025 2.87.223 1.062.18 1.6.383 2.674.168 1.19.194 1.985.164 2.588-.024.5-.173 1.502-.15 1.851.024.349.192.562.614.782z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_11610">
					<path fill="#fff" d="M0 0H90V90H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
